import axios from 'axios'

export default {
  namespaced: true,
  state: {
    current_track: {
      album: {
        uri: undefined, // ex: "spotify:album:0cPpV0WUt1URMHDjPXkH7f"
        name: undefined, // ex: "ไปได้ดี"
        images: [
          // {
          //   height: 300,
          //   url: 'https://i.scdn.co/image/ab67616d00001e02af40f6f0d51edbae1f98a96f',
          //   width: 300
          // }
        ]
      },
      artists: [
        // {
        //   name: 'Wanyai',
        //   uri: 'spotify:artist:3yLZtAIGm6Eq4WSfnimZad'
        // }
      ],
      duration_ms: undefined,
      id: undefined, // '2qlfZhBPWq5FH3FwlZKGws',
      is_playable: false,
      name: undefined, // "ไปได้ดี",
      type: undefined, // "track"
      uri: undefined // "spotify:track:2qlfZhBPWq5FH3FwlZKGws"
    },
    device_id: undefined
  },
  mutations: {
    updateState (state, payload) {
      console.log(payload)
      for (let key in payload) {
        if (payload.hasOwnProperty(key)) {
          state[key] = payload[key]
        }
      }
    }
  },
  actions: {
    updateCurrentTrack ({ commit }, payload) {
      commit('updateState', { current_track: payload })
    },
    updateDeviceId ({ commit }, payload) {
      commit('updateState', { device_id: payload })
    },
    async playSongByURI ({ state }, payload) {
      try {
        await axios.put(
          `https://api.spotify.com/v1/me/player/play?device_id=${state.device_id}`,
          {
            uris: [payload]
          },
          {
            headers: {
              Authorization:
                `Bearer ${JSON.parse(localStorage.getItem('app_token')).access_token}`,
              'Content-Type': 'application/json'
            }
          }
        )
      } catch (e) {
        console.log(e.response)
      }
    }
  }
}
